import { render, staticRenderFns } from "./ReportRiskAreaAmount.vue?vue&type=template&id=99a3a9ec&scoped=true"
import script from "./ReportRiskAreaAmount.vue?vue&type=script&lang=js"
export * from "./ReportRiskAreaAmount.vue?vue&type=script&lang=js"
import style0 from "./ReportRiskAreaAmount.vue?vue&type=style&index=0&id=99a3a9ec&prod&scoped=true&lang=css"
import style1 from "./ReportRiskAreaAmount.vue?vue&type=style&index=1&id=99a3a9ec&prod&lang=css"
import style2 from "./ReportRiskAreaAmount.vue?vue&type=style&index=2&id=99a3a9ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a3a9ec",
  null
  
)

export default component.exports